module.exports = __webpack_public_path__ + "static/media/es.72e1ab1e.svg";